import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../AppContextProvider";
import ImportData from "../components/dataimport/ImportData";

function DataImportPage() {
  const context = useContext(AppContext);
  const [isDark, setIsDark] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (
      document.documentElement.getAttribute("data-color-mode") === "dark" ||
      document.documentElement.getAttribute("data-color-mode") === null
    ) {
      setIsDark(true);
    } else {
      setIsDark(false);
    }
  }, [context.getState()?.isRender]);

  return (
    <div style={{ width: "100%", padding: "0 32px" }}>
      <div style={{ padding: "0 24px" }}>
        <div className="dashboard">
          <ImportData />
        </div>
      </div>
    </div>
  );
}
export default DataImportPage;
